<ng-container *ngIf="loadingPage; else loadingPage">
  <main class="mh-100vh">
    <router-outlet></router-outlet>
    <app-layer></app-layer>
  </main>
  <app-error-toast></app-error-toast>
</ng-container>
<ng-template #loadingPage> <app-loading-screen></app-loading-screen> </ng-template>
